// lib/theme.ts
// مدیریت تم روشن/تیره (کوکی + localStorage). کوکی باعث میشه سرور هم از اول تم درست رو رندر کنه.

export type Theme = "light" | "dark";

export const THEME_COOKIE = "ittelecom_theme";
export const THEME_STORAGE_KEY = "ittelecom_theme";

const ONE_YEAR = 60 * 60 * 24 * 365;

// اگر فرانت و داشبورد روی ساب‌دامین‌های یک دامنه باشند (مثلاً .example.com) تم بین هر دو مشترک میشه
const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN
  ? `; domain=${process.env.NEXT_PUBLIC_COOKIE_DOMAIN}`
  : "";

export function getCurrentTheme(): Theme {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function applyTheme(theme: Theme, persist = true) {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.style.colorScheme = theme;

  if (!persist) return;

  try {
    document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=${ONE_YEAR}; SameSite=Lax${COOKIE_DOMAIN}`;
  } catch {}
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {}
}

/**
 * اسکریپت inline که داخل <head> قبل از اولین رندر اجرا میشه (بدون فلش/تاخیر).
 * اولویت: کوکی ← localStorage ← تم سیستم کاربر
 */
export const themeInitScript = `(function(){try{var m=document.cookie.match(/(?:^|; )${THEME_COOKIE}=(dark|light)/);var t=m?m[1]:null;if(!t){try{t=localStorage.getItem('${THEME_STORAGE_KEY}')}catch(e){}}if(t!=='dark'&&t!=='light'){t=(window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches)?'dark':'light'}var d=document.documentElement;if(t==='dark'){d.classList.add('dark')}else{d.classList.remove('dark')}d.style.colorScheme=t;}catch(e){}})();`;
